import React from 'react';
import CommunicationProcessList from './communicationProcessList';
import RouteMenu from 'mrf/view/MenuRoute';

export default function CommunicationProcess({ match }) {
    return (
        <RouteMenu match={match} indexComponent={CommunicationProcessList}>
        </RouteMenu>
    );
}